import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ThreePeopleOutlineIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <g fill="#222" clipPath="url(#clip0_18625_2904)">
            <path d="M16.24 13.65C15.07 13.13 13.63 12.75 12 12.75 10.37 12.75 8.93 13.14 7.76 13.65 6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65zM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31 9.95 14.93 10.97 14.75 12 14.75 13.03 14.75 14.05 14.93 15.02 15.31 15.79 15.61 15.83 15.77 15.93 16H8.07zM12 8C12.55 8 13 8.45 13 9 13 9.55 12.55 10 12 10 11.45 10 11 9.55 11 9 11 8.45 11.45 8 12 8zM12 6C10.34 6 9 7.34 9 9 9 10.66 10.34 12 12 12 13.66 12 15 10.66 15 9 15 7.34 13.66 6 12 6zM18.5314 12.521C19.7635 12.521 20.7623 11.5221 20.7623 10.29 20.7623 9.05791 19.7635 8.05908 18.5314 8.05908 17.2992 8.05908 16.3004 9.05791 16.3004 10.29 16.3004 11.5221 17.2992 12.521 18.5314 12.521zM5.46885 12.521C6.70096 12.521 7.69979 11.5221 7.69979 10.29 7.69979 9.05791 6.70096 8.05908 5.46885 8.05908 4.23674 8.05908 3.23792 9.05791 3.23792 10.29 3.23792 11.5221 4.23674 12.521 5.46885 12.521z" />
            <path d="M1 16.9897H4.56469C4.8669 15.3613 5.69535 13.877 6.92281 12.765 6.24988 12.5335 5.53137 12.466 4.82709 12.5682 4.12281 12.6703 3.45311 12.9393 2.87374 13.3525 2.29437 13.7658 1.82207 14.3114 1.49616 14.9441 1.17024 15.5767 1.00014 16.2781 1 16.9897zM18.5314 12.521C18.0365 12.5212 17.545 12.6037 17.0771 12.765 18.3046 13.877 19.1331 15.3612 19.4353 16.9897H23C23 15.8045 22.5291 14.6679 21.6911 13.8298 20.853 12.9917 19.7165 12.521 18.5314 12.521z" />
          </g>
          <defs>
            <clipPath id="clip0_18625_2904">
              <path fill="#fff" d="M0 0H24V24H0z" />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    )
  },
)
